import { Helmet } from "react-helmet";
import AboutUsLayout from "../sections/aboutUsSection/aboutUsLayout";

const AboutUsPage = () => {
    return (
        <>
            <Helmet>
                <title>About code3x | AI, Gaming & Digital Solutions Innovators</title>
                <meta name="description" content="Learn about code3x, a hub for AI, games, and digital solutions. Discover our mission to transform ideas into impactful innovations." />
                <meta name="keywords" content="about code3x, AI company, gaming studio, digital solutions firm, innovation, code3x story, leading tech company, Sri Lanka" />
                <link rel="canonical" href="https://code3x.tech/about-us" />
            </Helmet>

            <AboutUsLayout />
        </>
    );
}

export default AboutUsPage;